var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04218 20.6119C6.47218 20.6119 5.91218 20.4619 5.39218 20.1619C4.35218 19.5619 3.74219 18.5019 3.74219 17.3019V7.73186C3.74219 6.54186 4.36218 5.47188 5.39218 4.87188C6.43218 4.27187 7.66217 4.27187 8.69217 4.87188L16.9822 9.65187C18.0122 10.2519 18.6322 11.3219 18.6322 12.5119C18.6322 13.7019 18.0122 14.7719 16.9822 15.3719L8.69217 20.1519C8.17217 20.4619 7.61218 20.6119 7.04218 20.6119ZM7.04218 5.93187C6.73218 5.93187 6.42218 6.01186 6.14218 6.17186C5.58218 6.50186 5.24219 7.08186 5.24219 7.73186V17.3019C5.24219 17.9519 5.58218 18.5319 6.14218 18.8619C6.70218 19.1819 7.38217 19.1919 7.94217 18.8619L16.2322 14.0819C16.7922 13.7519 17.1322 13.1719 17.1322 12.5219C17.1322 11.8719 16.7922 11.2919 16.2322 10.9619L7.94217 6.18187C7.66217 6.02187 7.35218 5.93187 7.04218 5.93187Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9766 19.4537C20.5666 19.4537 20.2266 19.1137 20.2266 18.7037V6.34375C20.2266 5.93375 20.5666 5.59375 20.9766 5.59375C21.3866 5.59375 21.7266 5.93375 21.7266 6.34375V18.7037C21.7266 19.1137 21.3966 19.4537 20.9766 19.4537Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext1);
export default __webpack_public_path__ + "static/media/next (1).536cc9a23d6f421f2845cd075e73629a.svg";
export { ForwardRef as ReactComponent };